import React from 'react';

export const SourcesContext = React.createContext({});
